const digest = 'fe9390592bde75d16872f709d2434cdfd6ef7f11d0b3809462f1a7b9265872dd';
const css = `._badge_9fob1_1{font-size:.5rem;padding:.25rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'badge': '_badge_9fob1_1' };
export const badge = '_badge_9fob1_1';
export { css, digest };